import { render } from "./UpcomingLecture.vue?vue&type=template&id=0721af3f&scoped=true"
import script from "./UpcomingLecture.vue?vue&type=script&lang=js"
export * from "./UpcomingLecture.vue?vue&type=script&lang=js"

import "./UpcomingLecture.vue?vue&type=style&index=0&id=0721af3f&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0721af3f"]])

export default __exports__